import { CommonModule, DecimalPipe, registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule, Injectable } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMapboxGLModule } from 'ngx-mapbox-gl';

import { TimeagoCustomFormatter, TimeagoFormatter, TimeagoIntl, TimeagoModule } from 'ngx-timeago';
import { strings as ptBrStrings } from 'ngx-timeago/language-strings/pt';
import { environment } from 'src/environments/environment.prod';
import { DisableControlDirective } from '../core/components/disableControl/disableControl.component';
import { ClickOutsideDirective } from '../core/directive/clickoutside';
import { CurrencyCustomPipe } from '../core/pipe/pipe-currencyCustom';
import { DateToString } from '../core/pipe/pipe-date';
import { PipeObjectFilter } from '../core/pipe/pipe-objectFilter';
import { DatetimeToString } from '../core/pipe/pipe-datetime';
import { SuppressBlockComponent } from './components/suppress-block/suppress-block.component';

import { LazyLoadImageModule  } from 'ng-lazyload-image';
import { FilterUnitPipe } from '../core/pipe/pipe-filterUnit';
import { PipeObjectIntersect } from '../core/pipe/pipe-objectIntersect';
import { PipeCheckAllow } from '../core/pipe/pipe-checkAllow';
import { PipeMainMenuItems } from '../core/pipe/pipe-mainMenuItems';
import { PipeMainMenuItemClass } from '../core/pipe/pipe.mainMenuItemClass';
import { PipeHasPromotion } from '../core/pipe/pipe-hasPromotion';
import { PipeNoSanitize } from '../core/pipe/pipe-noSanitize';
import { PipeCheckboxIsChecked } from '../core/pipe/pipe-checkboxIsChecked';
import { PipeErrorMessage } from '../core/pipe/pipe-errorMessage';
import { PipeZipcodeIsValid } from '../core/pipe/pipe-zipcodeIsValid';
import { PipeUnitTypesByBlockId } from '../core/pipe/pipe-unitTypesByBlockId';
import { NgxSliderModule } from '@m0t0r/ngx-slider';
import { PipeTagFilter } from '../core/pipe/pipe-tagFilter';
import { FileSizeFormatPipe } from '../core/pipe/pipe-fileSizeFormat';
import { PipeHasFileSelected } from '../core/pipe/pipe-hasFileSelected';
import { TimestampToString } from '../core/pipe/pipe-timestamp';
import { PipeCompanieAllow } from '../core/pipe/pipe-companieAllow';
import { PipePinClass } from '../core/pipe/pipe-pinclass';
import { PinchZoomModule } from 'ngx-pinch-zoom';
import { QRCodeModule } from 'angularx-qrcode';
import { ToDoublePipe } from '../core/pipe/pipe-toDouble';
import { KeysPipe } from '../core/pipe/pipe-keys';
import { LetDirective } from '../core/directive/ng-let';
import { detectUrlPipe } from '../core/pipe/pipe-detectUrl';
import { PipeGetTag } from '../core/pipe/pipe-getTag';
import { PersonFilterPipe } from '../core/pipe/pipe.personFilter';

registerLocaleData(localePt);

@Injectable({
  providedIn: 'root'
})
export class PtBRTimeagoIntl extends TimeagoIntl {
  
  constructor() {
    super();
    this.strings = ptBrStrings;  
    this.changes.next();
  }
}

@NgModule({
  declarations: [
    DisableControlDirective,
    DateToString,
    TimestampToString,
    DatetimeToString,
    ClickOutsideDirective,
    LetDirective,
    PipeHasFileSelected,
    FileSizeFormatPipe,
    detectUrlPipe,
    PipeObjectFilter,
    PipeObjectIntersect,
    PipeCheckAllow,
    PipeCheckboxIsChecked,
    PipeErrorMessage,
    PipeMainMenuItems,
    PipeMainMenuItemClass,
    PipeHasPromotion,
    PipeNoSanitize,
    PipeZipcodeIsValid,
    PipeUnitTypesByBlockId,
    PipeTagFilter,
    PipeCompanieAllow,
    PipePinClass,
    FilterUnitPipe,
    KeysPipe,
    PipeGetTag,
    CurrencyCustomPipe,
    ToDoublePipe,
    PersonFilterPipe,
    SuppressBlockComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PinchZoomModule,
    NgxMapboxGLModule.withConfig(environment.mapbox),
    HttpClientModule,
    TimeagoModule.forRoot({
      intl: { provide: TimeagoIntl, useClass: PtBRTimeagoIntl },
      formatter: { provide: TimeagoFormatter, useClass: TimeagoCustomFormatter },
    }),
    NgxSliderModule,
    LazyLoadImageModule,
    QRCodeModule
  ],
  exports: [
    DisableControlDirective,
    DateToString,
    DatetimeToString,
    TimestampToString,
    ClickOutsideDirective,
    LetDirective,
    PipeHasFileSelected,
    FileSizeFormatPipe,
    detectUrlPipe,
    PipeObjectFilter,
    PipeTagFilter,
    PipeMainMenuItems,
    PipeMainMenuItemClass,
    PipeObjectIntersect,
    PipeCheckAllow,
    PipeCheckboxIsChecked,
    PipeHasPromotion,
    PipeNoSanitize,
    PipeErrorMessage,
    PipeZipcodeIsValid,
    PipeUnitTypesByBlockId,
    PipeCompanieAllow,
    PipePinClass,
    CurrencyCustomPipe,
    ToDoublePipe,
    FilterUnitPipe,
    KeysPipe,
    PipeGetTag,
    PersonFilterPipe,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    
    NgxSliderModule,    
    NgxMapboxGLModule,
    HttpClientModule,
    TimeagoModule,
    SuppressBlockComponent,
    LazyLoadImageModule,
    PinchZoomModule,
    QRCodeModule
  ],
  providers: [
    {provide: LOCALE_ID, useValue: 'pt-BR'},
    DecimalPipe
  ]
})
export class SharedModule {

}
